import { Box, Button, Grid2 as Grid, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { ImportContacts } from "@mui/icons-material";
import { ErrorSection } from "../components/Error";
import { get_Event_list } from "../FirebaseUtils/dbEvent";
import { format, isSameDay } from "date-fns";
import { myTimestampToDate } from "../utils/ui_utils";

import { Footer } from "../components/Footer";

export default function EventSelectorView() {
    const errorRef = useRef()

    const [event_list, setEventList] = useState([])


    useEffect(() => {
        const cb_error = (msg) => {
            console.log("ERRORE DATI", msg)
        }
        const initData = async () => {
            const res = await get_Event_list(cb_error, true)
            setEventList(res.filter(s => !s.is_debug))
        }
        initData()
    }, [])

    return (
        <>
            <Box sx={{ textAlign: 'center', }} component="form" autoComplete="off" flexDirection={"column"}>
                <Box justifyContent={"center"}>
                    <img src="/logo-ANAFIBJ-600.png" width="200px" alt="" />
                    <Typography
                        sx={{ width: '100%', fontSize: '40px', fontWeight: 'bold', color: '#8fb5d7' }}
                    >
                        ShowTimeANAFIBJ
                    </Typography>
                </Box>

                <Box sx={{ backgroundColor: '#8fb5d7', padding: 1 }}>
                    {event_list.length === 0 ?
                        <>
                            Nessun evento in corso
                        </>
                        :
                        <>
                            Eventi in corso
                        </>
                    }
                </Box>
                <Grid container spacing={2} justifyContent={"center"} sx={{ mt: 2 }}>
                    {event_list.map((e, k) => (
                        <OneEvent
                            key={k}
                            event={e}
                            index={k}
                        />
                    ))}
                </Grid>
                <ErrorSection ref={errorRef} text={"Event Code not correct"} autohide={5000} />
            </Box>
            <Footer />
        </>
    );


}


const OneEvent = ({ event }) => {

    const ev_start = myTimestampToDate(event.event_start)
    const ev_end = myTimestampToDate(event.event_end)
    let ev_date = format(ev_start, 'dd/MM/yyyy')
    if (!isSameDay(ev_start, ev_end)) {
        ev_date = `dal ${format(ev_start, 'dd/MM/yyy')} al ${format(ev_end, 'dd/MM/yyyy')}`
    }

    return (
        <Grid container sx={{ border: '1px solid #8fb5d7', padding: 2, borderRadius: 4, }} flexDirection={"column"} spacing={1}>
            <Grid size={"grow"} sx={{ fontWeight: 'bold', fontSize: '1.1em', backgroundColor: '#8fb5d7', color: 'white', paddingLeft: 1, paddingRight: 1 }}>
                {event.event_name}
            </Grid>
            <Grid size={"grow"}>
                {ev_date}
            </Grid>
            <Grid size={"grow"}>
                <i>presso:</i> {event.location?.name}
            </Grid>
            <Grid size={"grow"}>
                <i>giudice:</i> {event.judge?.firstname} {event.judge?.lastname}
            </Grid>
            <Grid size={"grow"}>
                <i>id protocollo:</i> {event.id_protocol}
            </Grid>
            <Grid size={"grow"}>
                <Button fullWidth href={`${event.id}/publiccatalog`} variant="outlined" startIcon={<ImportContacts />}>Apri</Button>
            </Grid>
        </Grid>

    )
}


